<template lang='pug'>
v-app(class='app')
  v-content
    v-container(fluid fill-height)
      v-layout(justify-center align-center)
        v-flex(shrink)
          s-slide-fade
            router-view
  s-snack
</template>

<script>
export default {}
</script>

<style scoped lang='scss'>
.app {
  background: #f5f5f5;
}
</style>
